import * as React from 'react';
import {
  PageSection,
  Title,
  Form,
  FormGroup,
  TextInput,
  DatePicker,
  Grid,
  FormSection,
  Button,
} from '@patternfly/react-core';
import { TCertification } from '@app/config/types';
import { StoreContext } from '@app/store';
import { ADD_CERTIFICATION, ARRAY_CHILD_CHANGE, REMOVE_ITEM_FROM_ARRAY } from '@app/config/constants';

const CertificationForm: React.FunctionComponent = () => {
  const { state, dispatch } = React.useContext(StoreContext);
  return (
    <PageSection>
      <Title headingLevel="h1" size="lg">
        My Information
      </Title>
      <Form onSubmit={(e) => e.preventDefault()}>
        {state.certifications.map((item: TCertification, index) => (
          <FormSection key={index}>
            <Grid hasGutter md={6}>
              <FormGroup label="Certification/License" isRequired fieldId="simple-form-name-01">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-01"
                  name="simple-form-name-01"
                  aria-describedby="simple-form-name-01-helper"
                  value={item.name}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'certifications',
                        index,
                        childKey: 'name',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>

              <FormGroup label="Date" isRequired fieldId="simple-form-link-01">
                <DatePicker thesis />
              </FormGroup>
              <Button
                variant="danger"
                onClick={() =>
                  dispatch({
                    type: REMOVE_ITEM_FROM_ARRAY,
                    payload: {
                      key: 'certifications',
                      index,
                    },
                  })
                }
              >
                Remove Certification
              </Button>
            </Grid>
          </FormSection>
        ))}
        <Button
          variant="primary"
          onClick={() =>
            dispatch({
              type: ADD_CERTIFICATION,
            })
          }
        >
          Add Certification
        </Button>
      </Form>
    </PageSection>
  );
};

export { CertificationForm };
